<div class="setting-page">
  <legend>CDR</legend>
  <arm-form  (submitForm)="submit()" [disableSubmit]="formNotValid">
    <arm-form-title>CDR Values</arm-form-title>
    <form #mapForm="ngForm">

    <div class="settings-section">
      <p>
        <mat-slide-toggle [(ngModel)]="cdrSettings.enabled"  color="primary" name="enabled" >
          Enable CDR
        </mat-slide-toggle>
      </p>


      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Host</mat-label>
          <input matInput [(ngModel)]="cdrSettings.host" name="host" required [disabled]="!cdrSettings.enabled">
          <mat-error>
            Host is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Port</mat-label>
          <input type="number" matInput [(ngModel)]="cdrSettings.port" [min]="1" [max]="65535" name="port" required [disabled]="!cdrSettings.enabled" >
        </mat-form-field>
      </p>

      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Protocol</mat-label>
          <mat-select required [(ngModel)]="cdrSettings.protocol" name="protocol" [disabled]="!cdrSettings.enabled">
            <mat-option *ngFor="let item of protocolOptions" [value]="item" >
              {{item}}
            </mat-option>
          </mat-select>
          <mat-error>
            Protocol is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Format</mat-label>
          <mat-select required [(ngModel)]="cdrSettings.cdrFormat" name="format" [disabled]="!cdrSettings.enabled">
            <mat-option *ngFor="let item of cdrTypesOptions" [value]="item.value">
              {{item.name}}
            </mat-option>
          </mat-select>
          <mat-error>
            Format is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </p>





    </div>

    </form>
  </arm-form>
</div>
